module.exports = __webpack_public_path__ + "static/media/Logo_Yo-mockup.2fbb3293.jpg";